import { Collapse, Stack, Typography } from "@mui/material";
import { ChevronLeftIcon } from "../images";

type Props = {
  title: string;
  isExpanded: boolean;
  onExpend: (tier: string) => void;
  children?: React.ReactNode;
};

export const TierAccordion = ({
  title,
  isExpanded,
  onExpend,
  children,
}: Props) => {
  const expendHandler = () => {
    onExpend(title);
  };
  return (
    <Stack
      sx={{
        borderRadius: "6px",
        backgroundColor: "#F7F7F7",
        padding: isExpanded ? "0 8px 8px 8px" : "0 8px",
      }}
    >
      <Stack
        flexDirection={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        sx={{ width: "100%", cursor: "pointer" }}
        onClick={expendHandler}
      >
        <Typography
          variant={"button"}
          sx={{ color: "#232323", paddingLeft: "12px" }}
        >
          {title}
        </Typography>
        <ChevronLeftIcon rotate={isExpanded ? "90" : "-90"} />
      </Stack>

      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <Stack sx={{ gap: "8px", width: "100%", pt: "8px" }}>{children}</Stack>
      </Collapse>
    </Stack>
  );
};
